define('models/CartModel',['jquery',  'underscore', 'ObjectModel', 'LocalStorage', 'app', 'site_vars', 'hooks',
'sprintf', 'ApiRequest', 'formatPrice', 'moment', 'momentFormats',
'models/CartProductCollection',
        'models/OfferedProductCollection',
        'models/AddressCollection',
        'models/AddressModel',
        'PlaceModel',
        'models/OfferedProductModel',
        'models/PaymentMethodCollection',
        'models/CheckoutModel',
        'views/blocks/FreeProductChoiceVoucherView',
        'views/blocks/DateTimeSelectorView',
        'views/pages/ProductPageView',
        'views/pages/AuthentificationPageView',
        'AddressAutocompleteView',
        'views/blocks/ConsumableOptionsView',
        'TagCommander',
        'prototypes/ReCaptcha',
        ],
    function ($, _, ObjectModel, LocalStorage, app, site_vars, hooks,
              sprintf, ApiRequest, formatPrice, moment, momentFormats,
              CartProductCollection,
              OfferedProductCollection,
              AddressCollection,
              AddressModel,
              PlaceModel,
              OfferedProductModel,
              PaymentMethodCollection,
              CheckoutModel,
              FreeProductChoiceVoucherView,
              DateTimeSelectorView,
              ProductPageView,
              AuthentificationPageView,
              AddressAutocompleteView,
              ConsumableOptionsView,
              TagCommander,
              ReCaptcha
    )
    {
        //
        // Model Cart
        //

        // var SLUG_CONSUMABLES = ['baguettes','sauce_sucree','sauce_salee','gingembre','wasabi'];
        //
        // WARNING > "offored" (et non offered) est le maintien d’une coquille,
        // présente dans le schéma du modèle de données.
        // la coquille a été corrigée dans tous le FRONT sauf ici — où elle est maintenue volontairement.
        var FAVORITE_PRODUCT_OFFERED_PREFIX = 'favorite_product_offored_';
        var CHECK_PRODUCT_LAST_MESSAGE,
            UNAVAILABLE_ID_PRODUCTS_HASH = 'unavailable_id_products_hash',
            STOCKOUT_AVAILABLE_MSG = 'STOCKOUT';
        //

        var ZERO_DATE = '0000-00-00',
            CART_DATE_FORMAT = 'YYYY-MM-DD',
            CART_TIME_FORMAT = 'HH:mm:ss',
            //
            CART_DATETIME_FORMAT = CART_DATE_FORMAT+' '+CART_TIME_FORMAT;
        //
        var SECOND_IN_MS = 1000, MINUTE_IN_MS = SECOND_IN_MS * 60, HOUR_IN_MS = MINUTE_IN_MS * 60,
            UI_WARNING_TEXT = 'Attention',
            UI_CONTEXT = 'UI',
            CART_TRANSLATION_CONTEXT = 'Cart';

        function ScopedCartModel() {

            // private scope variables
            var cart, cartProductCollection,cartUnavaibleProductCollection, cartConsumablesCollection, cartExtraPriceCollection, cartRefreshTimeout,
                paymentMethod,
                paymentMode,

                offeredProductCollection,
                productCollections = _([]),
                invalidSidedishesProducts = [];

            var CartModelPrototype = {

                name: 'CartModel', route: 'apiCartModel', idAttribute: 'id_cart',
                translated: false,
                privateApi: true,


                defaults: {
                    total_cart_quantity: 0,
                    id_cart: 'current',
                    virtual: false,
                    products: [],
                    consumables: [],
                    consumables_qty: {},
                    unavailable_products: [],
                    extraPrice: [],
                    payment_restrictions: {},
                    store_closed: null,
                },

                initialize: function () {
                    // ObjectModel constructor heritage
                    ObjectModel.prototype.initialize.apply(this, arguments);
                    //
                    //
                    cart = this;

                    cart.softFetch();
                    //
                    // annule les vérifications utilisateur
                    cart.set({
                        offeredProductsCheckSum:false,
                        deliveryAddressDataCheckSum:false
                    },{silent:true});
                    //
                    // si on a pas d'options de livraison
                    if(!cart.getDeliveryOptions()){
                        cart.set('deliveryOptions',null);
                    }
                    cart.site_vars = site_vars;
                    cart.checkout_rewrite  = site_vars.checkout_url;
                    cart.on('request', cart.onRequest, cart);
                    // cart.on('productsChange',cart.onProductsChange,cart)
                    // cart.on('change:'+UNAVAILABLE_ID_PRODUCTS_HASH,cart.onChangeUnavailableProducts,cart)


                    cart.listenTo(app,'NEEDRECAPTCHAError',cart.onNEEDRECAPTCHAError);

                    // Fonction d'instanciation des CartProductCollection,
                    // à partir de l'identifiant du tableau de produit
                    function AttachCartProductCollection(id){
                        var collection = new CartProductCollection();
                        collection.attachCart(cart,id);
                        return collection;
                    }

                    // instancie les Cart Product Collection du panier
                    cartProductCollection = AttachCartProductCollection('products');
                    cartConsumablesCollection = AttachCartProductCollection('consumables');
                    cartUnavaibleProductCollection = AttachCartProductCollection('unavailable_products');
                    cartExtraPriceCollection = AttachCartProductCollection('extraPrice');

                    productCollections.push(cartProductCollection,cartConsumablesCollection,cartUnavaibleProductCollection,cartExtraPriceCollection);

                    //
                    cart.on('datetimePassed', cart.onDatetimePassed);
                    cart.on('change:store_closed', cart.onChangeStoreClosed);
                    //

                    // virtual
                    cart.set('virtual',cart.id == 'virtual');
                    if(!cart.isVirtual()){
                        // si on est sur le panier principal
                        cart.refresh(true);
                    }

                },
                onNEEDRECAPTCHAError: function(e){
                    var cart = this;
                    ReCaptcha("order", function (token) {
                        //worf
                        cart.token = token;

                      //  customer.requestLogin('Login', _.pick(datas, 'token', 'email', 'password', 'password_v2', 'password_v2_confirmation'));
                    }, function (err) {
                        var message = app.t('Une erreur est survenue, liée à ReCaptcha, vérifiez peut-être votre logiciel antipub.','Account');
                        app.banNotice(message);
                        app.error('ReCaptchaError');
                       // customer.trigger('loginFail', customer, err, message, datas);
                    })
                },
                ApiRequest:function(type,data,urlOptions,options){
                    return cart.pipeAppHttpHeaders(ApiRequest(type,data,urlOptions,options));
                },

                isNowLunch:function(){
                    return app.isNowLunch(cart.getDatetime());
                },
                setProductLikeOffered:function (id_cart_product, sidedishes) {
                    var options = {
                        id_cart_product:id_cart_product,
                    };
                    if(sidedishes){
                        _(options).extend({
                            sidedishes:sidedishes
                        })
                    }
                    return cart.ApiRequest('CartSetProductLikeOffered', options, {id_cart: cart.id})
                        .done(function (data) {
                            cart.set(data);
                            app.trigger('setProductLikeOffered');
                        })
                        .fail(function (response, status, data) {

                        })
                },

                onChangeStore:function()
                {
                    var store = cart.getStore();
                    if (store) {
                        store.once('sync',function(){
                            cart.trigger('storeSync',store);
                        });
                        store.fetch();
                    }
                },

                productCanBeOffered:function () {
                    return this.get('favorite_product_offored') ;
                },
                setup: function (callback) {
                    cartProductCollection.on('add', cart.onAddProduct, cart);
                    cartProductCollection.on('remove', cart.onRemoveProduct, cart);
                    cartUnavaibleProductCollection.on('add', cart.triggerEmptyOrUnavailable, cart);
                    cartUnavaibleProductCollection.on('remove', cart.triggerEmptyOrUnavailable, cart);
                    cart.on('change', cart.onChange, cart);
                    cartProductCollection.on('change', cart.onChange, cart);
                    cart.on('change:id_store', cart.onChangeStore, cart);
                    //
                    cart.listenTo(cartProductCollection,'change add remove delete',cart.updateProductPaymentRestrictions);
                    cart.on('change:id_store change:vae storeSync',cart.updateProductPaymentRestrictions);
                    cart.updateProductPaymentRestrictions();
                    //
                    function AfterSetup(store) {

                        /*
                        _(SLUG_CONSUMABLES).each(function (slug, key) {

                            var slug_format = '_'+slug.toUpperCase()+'_';
                            var idProduct =   app.c(slug_format, 0);
                            if (!idProduct || !app.getProduct(idProduct))
                            {
                                SLUG_CONSUMABLES = _(SLUG_CONSUMABLES).without(slug);
                            }
                        });
                        */
                        if (store) {
                            store.off('sync', AfterSetup);
                        }

                        var contextAttr = ['order_date','order_time','now','vae','id_store'];
                        _(contextAttr).each(function(key){
                            cart.on('change:'+key, cart.onChangeContext);
                        });

                        //cart.validateDatetime();



                        if (!_.isNull(cart.getDeliveryOptions()) && cart.isNow() && cart.getStore()) {
                            //
                            //cart.setDeliveryOptions(cart.getDeliveryOptions());
                            //
                            var datetime = cart.getDatetimeMoment(), delivery = cart.getDeliveryDelay();
                            //
                            var availableDatetime = cart.getStore().findAvailableDatetime(cart.isVAE());
                            if (Math.abs(moment(datetime.diff(delivery.date_min))) > HOUR_IN_MS) {
                                // si il y a une différence d'une heure ou plus on remet à jour les informations
                                try {
                                    cart.refreshDeliveryOptions(
                                        availableDatetime.moment.format(CART_DATE_FORMAT),
                                        availableDatetime.moment.format(CART_TIME_FORMAT)
                                    );
                                }catch(err){
                                    console.warn(err)
                                }
                            }
                            //
                            //
                        }
                        console.log("AfterSetup callback")
                        callback.call();
                    }

                    var store = cart.getStore();
                    if (store) {
                        store.fetchStockoutProduct(function(){
                            // on synchronise
                            store.on('sync', AfterSetup);
                            store.fetch();
                        });
                    } else {
                        AfterSetup();
                    }

                }, onRequest: function (model, attr, xhr) {
                    //
                    // si la réponse du serveur ne contient pas les informations locales, on essaie de mettre à jour
                    //
                    xhr.xhr.done(function (response, status) {
                        if (status == 'success') {
                            if (cart.get('id_store') != response.id_store) {
                                cart.refreshDeliveryOptions(response.order_date, response.order_time);
                            }
                        }
                    });
                },

                onChangeContext:function(a,b,c){
                    //if(!cart.validateDatetime()){
                    //    cart.trigger('changeContext',cart);
                    //}
                    if(!cart.validateDeliveryOptions()){
                        cart.trigger('deliveryUpdate',cart);
                    };
                },

                // validateDatetime:function(){
                //     //
                //     // vérifie la cohérence du crénaux horaire
                //     //
                //     var store = cart.getStore();
                //     if(store){
                //         var availableDatetime = store.findAvailableDatetime(cart.isVAE(),cart.getDatetime()),
                //             availableMoment = availableDatetime.moment,
                //             // créneau cible
                //             target = {
                //                 order_date : availableMoment.format(CART_DATE_FORMAT),
                //                 order_time : availableMoment.format(CART_TIME_FORMAT),
                //                 now : availableDatetime.now
                //             },
                //             // créneau actuel
                //             current = cart.pick('order_date','order_time','now');
                //         //
                //         if(availableDatetime.closed) return false;
                //         if(!_.isEqual(current,target)){
                //             // si il y a un changement entre actuel est cible
                //             //
                //             if(current.now == 1 && target.now != 1){
                //                 //
                //                 // si on doit passer de maintenant à plus tard, alors
                //                 // on force le serveur à se mettre à jour
                //                 // car il ne le fait pas seul
                //                 cart.setDeliveryDatetime(target.order_date,target.order_time,target.now);
                //             }
                //             if((target.now != current.now) || (target.now != 1)){
                //                 cart.set(target);
                //                 return false;
                //             }
                //         }
                //
                //     }
                //     return true;
                // },

                getExtraPrice:function() {


                    return cartExtraPriceCollection;
                },
                isVirtual:function(){
                    return cart.get('virtual');
                },
                onChange: function () {

                    // change delay shortcut event
                    var delayHasChanged = false;
                    _(['max','min']).each(function(m){_(['vae','vad']).each(function(t){
                        delayHasChanged = delayHasChanged || cart.hasChanged('delay_'+m+'_'+t);
                    })});
                    if(delayHasChanged){
                        cart.trigger('delayHasChanged');
                    }
                    cart.updateCagnotte();
                    //
                    // TODO : attention bug constaté, récursion des validations, incohérence client/server
                    // cart.validateDatetime();
                    //
                    cart.updateLocalStorageItem(); // met à jour localStorage
                    cart.refresh(true); // report refresh
                }, onAddProduct: function (model, collection, update) {
                    cart.trigger('addProduct');
                    if (cartProductCollection.size() == 1) {
                        cart.trigger('start', cart);
                    }
                }, onRemoveProduct: function (collection, model, update) {
                    cart.trigger('removeProduct', collection);
                    cart.triggerEmptyOrUnavailable();
                },
                // triggerOutStock:function(){
                //     var showPopUp = false;
                //     var outStockProducs = [],
                //         productLikeOffered;
                //
                //     cart.updateUnavaibleProduct()
                //
                //     cartUnavaibleProductCollection.each(function(product) {
                //         if (product.get('available_msg') === STOCKOUT_AVAILABLE_MSG) {
                //             showPopUp = true
                //             outStockProducs.push(product.id)
                //             if(product.isProductLikeOffered()){
                //                 productLikeOffered = true;
                //             }
                //         }
                //     });
                //
                //     if (!showPopUp) { return }
                //     app.alert({
                //         title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                //         subtitle:app.t('Votre panier contient un produit indisponible, celui-ci va etre retiré de votre panier',CART_TRANSLATION_CONTEXT),
                //         validation:app.t('Ok',UI_CONTEXT),
                //         }, function(){_(outStockProducs).each(function(id) {
                //             cart.deleteProduct(id)
                //         })
                //         if(productLikeOffered){
                //             cart.reopenFreeProductChoice()
                //         }
                //     })
                // },
                triggerEmptyOrUnavailable:function(){
                    var productsCount = cartProductCollection.size(),
                        productsUnavailableCount = cartUnavaibleProductCollection.size();
                    if (productsCount === 0 && productsUnavailableCount === 0 ) {
                        cart.trigger('empty', cart);
                    }else if(productsCount === 0){
                        cart.trigger('unavailable', cart);
                    }
                    cart.set({
                        productCount: productsCount,
                        productsUnavailableCount: productsUnavailableCount,
                    });
                },
                onDatetimePassed: function () {
                    var store = cart.getStore(), isVAE = cart.isVAE(), isNow = cart.isNow();
                    if (store) {
                        // si la date est passée, on essaie de la mettre à jour avec la date disponible la plus à jour
                        var availableDatetime = store.findAvailableDatetime(isVAE, cart.getDatetime());
                        if(!availableDatetime.closed)
                            cart.setDeliveryDatetime(
                                availableDatetime.moment.format(CART_DATE_FORMAT),
                                availableDatetime.moment.format(CART_TIME_FORMAT),
                                availableDatetime.now
                            );
                    }

                },
                onChangeStoreClosed:function(cart,isClosed){
                      cart.trigger('deliveryUpdate',cart);
                      if(isClosed && cart.getStore()){
                        app.confirm({
                            title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                            subtitle:app.t('Le créneau prévu pour votre commande est indisponible. Veuillez selectionner un autre créneau.','Cart'),
                            validation:app.t('Choisir un autre créneau')
                        },function(confirm){
                            if(confirm){
                                app.displayModal(new DateTimeSelectorView());
                            }else{
                                app.go('home');
                            }
                        })
                      }
                },
                isEmpty: function (withUnavailable,withConsumable) {
                    function rejectConsumable(p){return p.get('id_category_default') === app.getCategoryBySlug('CONSUMABLE').id}
                    var cartProductSize =
                        withConsumable ? cartProductCollection.size() :
                        cartProductCollection.reject(rejectConsumable).length || 0
                    if (withUnavailable)
                    {
                        cartProductSize +=
                            withConsumable ? cartUnavaibleProductCollection.size() :
                            cartUnavaibleProductCollection.reject(rejectConsumable).length || 0;
                    }
                    return cartProductSize <= 0;

                }, // vente à emporter
                isVAE: function () {
                    return cart.get('vae') === true;
                },
                isVAD: function () {
                    return !cart.isVAE();
                },
                // maintenant [1], aujourd'hui [0], un autre jour [-1]
                isNow: function () {
                    return cart.get('now') === 1;
                }, isAm: function () {
                    var store = cart.getStore(), datetime = cart.getDatetime();

                    if (store && datetime)
                        return cart.getStore().isDatetimeAm(cart.isVAE(), cart.getDatetime());
                }, //
                // test si le panier a bien toutes les options de livraison nécessaire
                validateDeliveryOptions: function () {
                    if (_.isUndefined(cart.getDatetime())) {
                        // est-ce qu'il y a une date de livraison
                        return false;
                    }
                    if (cart.getDatetimeMoment().diff() < 0) {
                        // est-ce que la date n'est pas passée
                        return false;
                    }
                    if (!cart.hasStore()) {
                        // est-ce qu'une boutique est attachée
                        return false;
                    }
                    if (cart.get('store_closed') === true) {
                        // est-ce qu'une boutique est attachée et explicitement fermée
                        return false;
                    }
                    if (cart.isVAE()) {
                        return (cart.getDatetimeMoment().diff() > 0);
                    } else {
                        return !_.isNull(cart.getDeliveryOptions()) || !_.isUndefined(cart.getAddressDelivery());
                    }
                },
                alertDeliveryOptions: function(){
                    // affiche une alerte si il n'y a pas d'options de commande valide
                    app.alert({
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t('Merci de renseigner votre adresse de livraison ou votre shop de retrait afin de passer votre commande',CART_TRANSLATION_CONTEXT)
                    },function(){
                        cart.requireDeliveryOptions();
                    });
                },
                alertEmptyCart: function(callback){
                    // affiche une alerte si il n'y a pas d'options de commande valide
                    app.alert({
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t('Votre panier est vide',CART_TRANSLATION_CONTEXT,cart.formatMinimumShippingPrice())
                    },callback)
                },
                alertMinimumPrice: function(callback){
                    // affiche une alerte si il n'y a pas d'options de commande valide
                    app.alert({
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t('Le montant minimum en livraison est de %s',CART_TRANSLATION_CONTEXT,cart.formatMinimumShippingPrice())
                    },callback)
                },
                alertRequiredSidedishes:function(){
                    app.trigger('alertRequiredSidedishes');
                    var cartProduct = cart.getProduct(invalidSidedishesProducts[0]);
                    app.confirm({
                        validation:app.t('Choisir',UI_CONTEXT),
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t('Veuillez selectionnez vos accompagnements obligatoires sur le produit %s',CART_TRANSLATION_CONTEXT,[cartProduct.getName()])
                    },function(success){
                        if(success){
                            app.displayModal(
                                new ProductPageView({
                                    id_product:cartProduct.getProduct().id,
                                    cartProduct:cartProduct
                                })
                            );
                        }
                    })
                },
                checkOfferedProducts:function(revalidate){
                    app.trigger('openConsumableOptionsView',cart,revalidate);
                },

                // retourne la date sur forme d'objet Date JS
                getDatetime: function () {
                    var od = cart.get('order_date'),
                        m = cart.getDatetimeMoment();
                    if (od == ZERO_DATE || !m.isValid()) return new Date();
                    return m.toDate();
                }, // retourne la date wrappé dans la librairie de formatage moment.js
                getDatetimeMoment: function () {
                    var od = cart.get('order_date'), ot = cart.get('order_time'),
                        m = (_(od).isUndefined() || od == ZERO_DATE || cart.isNow()) ? moment(new Date()).add(5,'m') : moment(od + ' ' + ot,CART_DATETIME_FORMAT);
                    return m;
                }, //
                // retourne le service, on concidère avant 16h comme matin après 16h comme soir
                getPeriod: function () {
                    var d = cart.getDatetime();
                    if (!d) return 'both';
                    var hours = cart.getDatetime().getHours();
                    return (hours > 2 && hours < 16) ? "am" : "pm";
                }, //
                formatDatetime: function (format) {
                    return cart.getDatetimeMoment().format(format);
                },
                hasStore: function(){
                    return !_.isUndefined(cart.getStore());
                },

                // retour les produits offerts, sauces, baguettes, gimgembre, wasabi
                getOfferedProducts:function(){
                    if(offeredProductCollection){
                        return offeredProductCollection;
                    }

                    var ids_fix = [];
                    /*
                    _(SLUG_CONSUMABLES).each(function (slug) {
                        var idProduct = app.c('_'+slug.toUpperCase()+'_');
                        ids_fix.push(idProduct);
                    });
                    */
                    offeredProductCollection = new OfferedProductCollection();

                    var other_consumables = app.getCategoryBySlug('CONSUMABLE');
                    other_consumables.getProductsCart(cart).each(function(product){
                       var id_product = product.id;
                       offeredProductCollection.add({
                            id_product: id_product
                        })
                    });

                    offeredProductCollection.attachCart(cart);
                    return offeredProductCollection;
                },

                preorder:function(id_product,display_product,callback){
                    var product = app.getProduct(id_product),
                        preorder_type = product.get('preorder_type'),
                        preorder_address_type = ['all','all','store','address'][preorder_type],
                        preorder_add_product = (!product.isMenu()) && (!display_product),
                        cart = app.getCart(),
                        preorderCart = cart,//new CartConstructor(cartOptions),
                        store = preorderCart.getStore(),
                        has_store = !!store,
                        has_wrong_delivery_type = preorder_address_type === (preorderCart.isVAE()?'address':'store'),
                        requireDeliveryOptionsCallback = displayDateTimeSelector;
                    ;
                    function displayDateTimeSelector(complete){
                        if(complete){
                            var dateTimeSelectorView = new DateTimeSelectorView({
                                cart:preorderCart,
                                preorder_product:product,
                                preorder_add_product:preorder_add_product,
                            });
                            cart.listenTo(dateTimeSelectorView,'complete',onDatetimeComplete);
                            cart.listenTo(dateTimeSelectorView,'close',onDatetimeComplete);
                            app.displayModal(dateTimeSelectorView);
                        }else{
                            simpleCallback(false);
                        }
                    }
                    function simpleCallback(confirm){
                        if(confirm && preorder_add_product){
                            preorderCart.addProduct(id_product, 1);
                        }
                        onDatetimeComplete(false,confirm);
                    }
                    function requireDeliveryOptionsCallbackTimeout(confirm){
                        if(product.isBuyableInContext()){
                            // si le produit est commandable sans changer le créneau
                            requireDeliveryOptionsCallback = simpleCallback;
                        }
                        setTimeout(function(){
                            requireDeliveryOptionsCallback(confirm);
                        },0, [confirm]);
                    }
                    function requireDeliveryOptions(confirm){
                        if(confirm){
                            preorderCart.requireDeliveryOptions(preorder_address_type,false,requireDeliveryOptionsCallbackTimeout,{
                                description:app.t('Sélectionnez un shop afin de vérifier la disponibilité du produit %s',CART_TRANSLATION_CONTEXT,product.getName()),
                            })
                        }
                    }
                    function onDatetimeComplete(view,success){
                        if(_.isFunction(callback)){
                            callback(success);
                        }
                    }
                    if(!has_store){
                        requireDeliveryOptions(true)
                    }else if(has_wrong_delivery_type){
                        var message = 'Ce produit est disponible uniquement %s. Pour le commander, vous devez basculer sur ce mode de livraison.',
                            modeName = app.t(preorder_address_type==='store'?'À emporter':'En livraison',CART_TRANSLATION_CONTEXT).toLowerCase();
                        app.confirm({
                            title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                            subtitle:app.t(message,CART_TRANSLATION_CONTEXT,modeName)
                        },requireDeliveryOptions)
                    }else{
                        displayDateTimeSelector(true)
                    }
                },


                getDeliveryOptions: function () {
                    return cart.get('deliveryOptions')
                },
                getDeliveryAddressData: function () {
                    return cart.get('deliveryAddressData') || {};
                },
                getDeliveryDelay: function () {
                    var v = cart.isVAE() ? 'vae' : 'vad',
                        d = cart.formatDatetime('YYYY/MM/DD '),
                        min = cart.get('delay_min_' + v),
                        max = cart.get('delay_max_' + v),
                        date_min = new Date(d + cart.get('order_time_min')),
                        date_max = new Date(d + cart.get('order_time_max'));
                    return {
                        date_min: date_min,
                        date_max: date_max,
                        moment_min: moment(date_min),
                        moment_max: moment(date_max),
                        delay_min: min,
                        delay_max: max,
                        diff: max - min
                    };
                }, formatDeliveryDelay: function (deliveryDelayFormat) {
                    var d = cart.getDeliveryDelay();
                    switch(deliveryDelayFormat){
                        //
                        case 'top-infos':
                            deliveryDelayFormat = "<span>" + app.t('Délai','Stores') + " :</span> " +
                                app.t('%s à %s min',CART_TRANSLATION_CONTEXT);
                            break;
                        // default delay format
                        case undefined :
                            deliveryDelayFormat = app.t('dans %s à %s min',CART_TRANSLATION_CONTEXT);
                            break;
                    }
                    return sprintf.sprintf(deliveryDelayFormat,d.delay_min,d.delay_max);
                },
                getPlace:function(){
                    var place_id = cart.get('place_id');
                    if(place_id) return PlaceModel.getPlace(place_id);
                },
                createAddressFromPlace:function(data,customer_primary){
                    // créé une addresse à partir des données paniers
                    return app.getAddresses().createAddressFromPlace(cart.getPlace(),true,data,customer_primary);
                },
                getVadMinTime: function () {
                    return cart.get('delay_min_vad')
                }, getVadMaxTime: function () {
                    return cart.get('delay_max_vad')
                }, getVaeMinTime: function () {
                    return cart.get('delay_min_vae')
                }, getVaeMaxTime: function () {
                    return cart.get('delay_max_vae')
                }, getQuantity: function () {
                    var q = 0;
                    cart.getProductsNonConsumable().each(function (cartProduct) {
                        q += cartProduct.getQuantity();
                    });
                    return q;
                    // return parseInt(cart.get('total_cart_quantity'));
                }, getConsumables: function () {
                    return cartConsumablesCollection;
                },

                getProducts: function () {
                    return cartProductCollection;
                },
                getProductsIndispo:function () {

                    return cartUnavaibleProductCollection;

                },
                getProduct: function(id_cart_product){
                    var cartProduct = cartProductCollection.get(id_cart_product);
                    if(!cartProduct){
                        // si le produit est indisponible.
                        cartProduct = cartUnavaibleProductCollection.get(id_cart_product);
                    }
                    return cartProduct;
                },
                // attention, la notion de slug n'existe pas vraiment sur les category
                getProductsByCategorySlug:function(categorySlug, invert){
                    var category = app.getCategoryBySlug(categorySlug);
                    if(category) return cart.getProductsByCategory(category, invert)
                },
                getProductsById:function(id_product, invert){
                    var products = cartProductCollection.filter(function (cartProduct) {
                        var product = cartProduct.getProduct();
                        return product.id  == id_product ? true  : false;
                    });
                    return _(products);
                },
                getProductsByCategory:function(category, invert){
                    var products = cartProductCollection.filter(function (cartProduct) {
                        var product = cartProduct.getProduct();
                        return product ? category.containsId(product.id) ^ invert : false;
                    });
                    return _(products);
                },
                hasProductOfCategorySlug:function(categorySlug){
                    var category = app.getCategoryBySlug(categorySlug);
                    return category ? cart.hasProductOfCategory(category) : false;
                },
                hasProductOfCategory:function(category){
                    var p = cart.getProductsByCategory(category);
                    if(p){return p.size()>0;}
                    return false;
                },
                getProductsByCategorySlugs:function(categorySlugsIgnored,invert){
                    var ignoredProductId = [],
                        products = cart.getProducts();
                    // l'option invert permet de filtrer en exclusion
                    invert = invert===true;
                    //
                    // uni tous les id products
                    _(categorySlugsIgnored).each(function(categorySlug){
                        var category = app.getCategoryBySlug(categorySlug);
                        if(category){ignoredProductId = _.union(ignoredProductId,category.getProductsId());}
                    });
                    ignoredProductId = _(ignoredProductId);
                    //
                    var filtred = _(products.filter(function(cartProduct){
                        var product = cartProduct.getProduct();
                        return product ? (ignoredProductId.contains(product.id) ^ invert) : false;
                    }));
                    return filtred;
                },
                getProductsDefaultCategory:function(){
                    // trie les produits et retourne tous les produits
                    // non boisson, accompagnement, dessert
                    return cart.getProductsByCategorySlugs(['drink','sidedish','consumable','dessert','consumable'],true);
                },
                getProductsNonConsumable:function(){
                    // _ wrapped
                    return _(cart.getProductsByCategorySlug('consumable',true));
                },
                getProductsDessertAndDrinkCategory:function(){
                    return cart.getProductsByCategorySlugs(['drink','dessert']);
                },
                getProductsSidedishCategory:function(){
                    return cart.getProductsByCategorySlugs(['sidedish']);
                },

                getPostcode: function () {
                    var postcodeModel;
                    if (cart.isVAE()) {
                        var store = cart.getStore()
                        if (store) {
                            postcodeModel = store.getPostcode()
                        }
                    } else {
                        postcodeModel = app.getPostcode(cart.getPostcodeId());
                        if(!postcodeModel){
                            var deliveryAddress = cart.getAddressDelivery();
                            if (deliveryAddress) {
                                return deliveryAddress.getPostcode();
                            }
                            var deliveryOptions = cart.getDeliveryOptions();
                            if (deliveryOptions) {
                                var postal_code = deliveryOptions.postal_code, id_postcode = deliveryOptions.id_postcode;
                                if(postal_code) return postal_code;
                                if(id_postcode){
                                    postcodeModel = app.getPostcode(id_postcode);
                                }
                            }
                        }
                    }
                    if(postcodeModel){
                        return postcodeModel.getPostcode();
                    }
                },
                getPostcodeModel:function(){
                    var postcodeModel = app.getPostcode(cart.get('id_postcode'));
                    if(!postcodeModel){
                        var postcode = cart.getPostcode();
                        postcodeModel = app.getPostcodeByValue(postcode);
                    }
                    return postcodeModel;
                },

                isFixedRecipe:function() {
                    // affiche le message, si un des produits est concerné par le message fixed_recipe
                    return cart.getProducts().some(function (cartProduct) {
                        return cartProduct.isFixedRecipe(); //fixed_recipe = fixed_recipe ||
                    });
                },

                getPieces: function () {
                    var p = 0;
                    cart.getProducts().each(function (cartProduct) {
                        var product = cartProduct.getProduct();
                        p += product ? product.getPieces() * cartProduct.getQuantity() : 0;
                    });
                    return p >= 0 ? p : 0;
                },
                displayPieces:function(){
                    var p = cart.getPieces(),t = app.t;
                    if(p>1) return t('%s pièces',CART_TRANSLATION_CONTEXT,p);
                    if(p==1) return t('une pièce',CART_TRANSLATION_CONTEXT);
                    return t('aucune pièce',CART_TRANSLATION_CONTEXT);
                },
                getAddressDelivery: function () {
                    var id_address_delivery = cart.get('id_address_delivery') || cart.getDeliveryOption('id_address'),
                        address = app.getAddress(id_address_delivery);
                    //if(!address && (id_address_delivery == 'fallback')){
                    //    // récupère les données en localstorage
                    //    address = new AddressModel({id_address:id_address_delivery});
                    //    address.localFetch();
                    //}
                    return address;
                },
                getAddressDeliveryData: function () {
                    var addressDelivery = cart.getAddressDelivery();
                    if (addressDelivery) {
                        return addressDelivery.getData();
                    }
                },
                getAddressCity:function(){
                    var postcode = cart.getPostcodeModel();
                    return postcode ? postcode.getCity() : '';
                },

                getCartProduct:function(id_cart_product){
                    // cherche le model CartProduct, à partir de l'id
                    var product;
                    productCollections.each(function(collection){
                        var p = collection.get(id_cart_product);
                        if(p) product = p;
                    });
                    return product;
                },
                getCartProductCollection:function(id_cart_product){
                    var product = cart.getCartProduct(id_cart_product);
                    // par défault, retourne la collection principale
                    return product ? product.collection : cartProductCollection;
                },

                addProduct: function (id_cart_product, quantity, options) {

                    return cart.getCartProductCollection(id_cart_product).addProduct(id_cart_product, quantity, options);
                }, addMultipleProduct: function (multipleProduct) {
                    return cartProductCollection.addMultipleProduct(multipleProduct);
                }, deleteProduct: function (id_cart_product, quantity) {
                    return cart.getCartProductCollection(id_cart_product).deleteProduct(id_cart_product, quantity);
                }, updateQuantityProduct: function (id_cart_product, quantity) {
                    return cartProductCollection.updateQuantityProduct(id_cart_product, quantity);
                }, updateProductSidedish: function(id_cart_product, sidedish){
                    // sidedish est un tableau
                    var updateCartProductCollection = cartProductCollection;
                    if(!updateCartProductCollection.get(id_cart_product)){
                        updateCartProductCollection = cartUnavaibleProductCollection;
                    }
                    updateCartProductCollection.updateProductSidedish(id_cart_product, sidedish);
                }, updateUnavaibleProduct: function() {
                    var collection = new CartProductCollection;
                    collection.attachCart(cart, 'unavailable_products');
                    cartUnavaibleProductCollection = collection;
                },
                getPriceTTC: function (options) {
                    var price = 0;
                    options = _.defaults(options,{
                        ignoreExtraPrices:false
                    });
                    try {
                        cart.getProducts().each(function(cartProduct) {
                            //
                            var product = cartProduct.getProduct();
                            if (product && product.isBuyableInContext(cart)) {
                                var cartProductPrice = cartProduct.getPrice(),
                                    computedPrice = product.getPrice('ttc', true, cart) * cartProduct.getQuantity();
                                price += cartProductPrice;
                                //
                                // ajoute le prix des accompagnements payants
                                // if (product.isMenu()) {
                                //     var sidedishes = cartProduct.getSidedishes();
                                //     sidedishes.each(function (sidedish) {
                                //         if (!sidedish.isFree()) {
                                //             sidedish.getSelectionCartProducts().each(function (sidedishCartProduct) {
                                //                 price += sidedishCartProduct.getPrice('ttc', true, cart)
                                //
                                //                 sidedishCartProduct.getExtraDisplayPrice().each(function (extraPrice) {
                                //                     price += (parseFloat(extraPrice.price_ttc) * sidedishCartProduct.getQuantity());
                                //                 })
                                //             });
                                //
                                //         }
                                //     })
                                // }
                                //
                                product.getExtraDisplayPrice().each(function ( extraPrice) {
                                    price += (parseFloat(extraPrice.price_ttc) * cartProduct.getQuantity());
                                })
                            }

                        });

                        //
                        if(!options.ignoreExtraPrices) {
                            cart.getExtraPrice().each(function (extraPrice) {

                                if (extraPrice.get('free') == false) {
                                    price += extraPrice.getPrice();
                                }
                            });
                        }

                        var discount = cart.get('total_discount');

                        price -= discount;

                        return Math.round(price * 100) / 100;
                    }catch(err){
                        // si il y a une erreur dans le calcul du prix
                        // on retourne Not a Number
                        return NaN;
                    }
                },
                getValueOf:function(key){
                    return parseFloat(this.get(key)) || 0;
                },
                getExtraPriceValue:function(type){
                    var price = 0;
                    cart.getExtraPrice().each(function (extraPrice) {
                        if (extraPrice.get('free') == false) {
                            price += extraPrice.getPrice(type);
                        }
                    });
                    return price;
                },
                getCategoriesOffered:function()
                {
                    return this.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'category') || [];
                },
                getPriceTTCWithoutDiscount: function () {
                    var price =  this.get('total_price_ttc_without_discounts');

                    return Math.round(price * 100) / 100;

                },
                hasTransfert:function()
                {
                    var id_store_transfered = cart.get('id_store_transfered');
                    if (id_store_transfered)
                    {
                        return true;
                    }else
                    {
                        return false;
                    }
                },
                getStoreTransfert:function()
                {
                    var id_store_transfered = cart.get('id_store_transfered');

                    return id_store_transfered;

                },
                getMinimumShippingPrice:function() {
                    var minValue = 0;
                    // si on est en livraison seulement
                    if(!cart.isVAE()){
                        var postcode = cart.getPostcodeId(),
                            district = cart.getDistrictId(),
                            store = cart.getStore();

                        if (cart.hasTransfert())
                        {

                            store = app.getStore(cart.getStoreTransfert())
                        }
                        if(store && postcode){
                            minValue = store.getMinimumShippingPrice(cart.getDatetime(),postcode,district);
                        }
                    }
                    return minValue;
                },
                formatMinimumShippingPrice:function(){
                    return formatPrice(cart.getMinimumShippingPrice());
                },
                hasMinimumPrice:function(){
                    var min = cart.getMinimumShippingPrice();
                    return min === 0 || cart.getMinimumShippingPrice() <= cart.getPriceTTCWithoutDiscount();
                },
                // onProductsChange:function(){
                  //var unavailable_id_products = [];
                  // cherche les produits indisponibles
                  // cart.getProducts().each(function(cartProduct){
                  //     var accompagnements = cartProduct.get('accompagnements');
                  //     _(accompagnements).each(function(a){
                  //         if(!!a.visible_error){
                  //             var id_product = a.id_product;
                  //             unavailable_id_products.push(id_product)
                  //         }
                  //     })
                  // });
                  // cart.getProductsIndispo().each(function(cartProduct){
                  //     var id_product = cartProduct.get('id_product');
                  //     unavailable_id_products.push(id_product)
                  // });
                  // var unavailable_id_products_hash = _(unavailable_id_products).uniq().join(',');
                  // cart.set(UNAVAILABLE_ID_PRODUCTS_HASH,unavailable_id_products_hash);
                // },
                // onChangeUnavailableProducts:function(){
                checkProducts:function(forceMessage,errorCallback,successCallback){
                    if(forceMessage) CHECK_PRODUCT_LAST_MESSAGE = false;
                    // vérifie la dispo produit
                    function goCart(){
                        app.go('cart');
                    }
                    function applyErrorCallback(){
                        if(cancelConsumablesIfNoStrictlyEmptyCart(applyErrorCallback)){
                            // noop
                        }else if(errorCallback){
                            errorCallback();
                        }else{ // comportement par défaut en cas d'erreur
                            goCart();
                        }
                    }
                    function applySuccessCallback(){
                        if(successCallback) successCallback();
                    }

                    var firstUnavailableCrossSellingProduct, firstUnavailableCrossSelling;

                    function doCheck(){
                        var message;

                        // test 1 : on vérifie que les cross-selling ne sont pas indisponibles
                        firstUnavailableCrossSellingProduct = cart.getProducts().find(function(cartProduct){
                            var accompagnements = cartProduct.get('accompagnements');
                            firstUnavailableCrossSelling = _(accompagnements).find(function(a){ return !!a.visible_error})
                            return !!firstUnavailableCrossSelling;
                        });
                        if(firstUnavailableCrossSellingProduct){
                            var unavailableProduct = app.getProduct(firstUnavailableCrossSelling.id_product)
                            message = app.t('Le produit %s dans la formule %s est actuellement indisponible.','Cart',[
                                unavailableProduct.getName(),
                                firstUnavailableCrossSellingProduct.getName()
                            ]);
                            alertNotice(message,afterConfirmProductCrossSellingMissing,app.t('Modifier',CART_TRANSLATION_CONTEXT),firstUnavailableCrossSellingProduct);
                            return false;
                        }

                        // test 2 : on vérifie que les cross-selling sont ok
                        var invalidSidedishes;
                        if(!(invalidSidedishes = cart.getInvalidSidedishes())){
                            firstUnavailableCrossSellingProduct = cart.getProduct(invalidSidedishes[0].id_cart_product);
                            message = app.t(
                                "Veuillez selectionnez vos accompagnements obligatoires sur le produit %s",
                                CART_TRANSLATION_CONTEXT,
                                [firstUnavailableCrossSellingProduct.getName()]
                            );
                            alertNotice(message,afterConfirmProductCrossSellingMissing,app.t('Choisir',CART_TRANSLATION_CONTEXT),firstUnavailableCrossSellingProduct);
                            // TODO
                            return false
                        }

                        // test 3 : on vérifie le produit préféré offert
                        var discount = cart.getFavoriteProductDiscount();
                        if(discount){
                            var hasProductOffered = cart.hasProductOfferedSelected(),
                                cartProductOffered = cart.getProductOfferedCartProduct();
                            if(!hasProductOffered || !cartProductOffered || !cartProductOffered.isAvailable()){
                                discount.force_cart_apear = '1';
                                var name = discount.name || '';
                                if(cartProductOffered){
                                    message = app.t(
                                        'Le produit %s inclus dans le coupon %s est actuellement indisponible. Veuillez en sélectionner un autre ou retirer le coupon.',
                                        CART_TRANSLATION_CONTEXT,
                                        [cartProductOffered.getName(),name]);
                                }else{
                                    message = app.t(
                                        'Le produit inclus dans le coupon %s n\'a pas été sélectionné. Veuillez en sélectionner un ou retirer le coupon.',
                                        CART_TRANSLATION_CONTEXT,
                                        [name]
                                    )
                                    ;
                                }
                                confirmNotice(message,afterConfirmProductOfferedMissing,app.t('Sélectionner',CART_TRANSLATION_CONTEXT),app.t('Retirer',CART_TRANSLATION_CONTEXT),discount);
                                return false;
                            }

                        }
                        // test 4 : on vérifie les produits indisponibles
                        var unavailable_id_products = [];
                        cart.getProductsIndispo().each(function(cartProduct){
                            var id_product = cartProduct.get('id_product');
                            unavailable_id_products.push(id_product)
                        });
                        var unavailable_id_products_unique = _(unavailable_id_products).uniq()
                        var uniqueLength = unavailable_id_products_unique.length;
                        if(uniqueLength>0){
                            var productsNames = _(unavailable_id_products_unique).map(function(id_product){
                                var product = app.getProduct(id_product);
                                 return product.getName() || '';
                            }).join(', '),
                                store = cart.getStore();
                            message = app.t(
                                uniqueLength>1 ?
                                    "Les produits %s sont indisponibles sur la boutique %s et vont être retirés du panier.":
                                    "Le produit %s est indisponible sur la boutique %s et va être retirés du panier.",
                                CART_TRANSLATION_CONTEXT,
                                [productsNames,store ? store.getName() : '']
                            );
                            alertNotice(message,afterConfirmProductUnavailable,app.t('Voir le panier',CART_TRANSLATION_CONTEXT),unavailable_id_products_unique);
                            return false;
                        }
                        applySuccessCallback();
                        return true;
                    }

                    // test 5 : on vérifie qu'on n'ait pas uniquement des produits complémentaires (sauces, etc)
                    if(cancelConsumablesIfNoStrictlyEmptyCart(doCheck)) return false;

                    function cancelConsumablesIfNoStrictlyEmptyCart(callback){
                        var notStrictlyEmpty = cart.isEmpty(true) && !cart.isEmpty(true,true);
                        if(notStrictlyEmpty) cart.removeProducts(callback);
                        return notStrictlyEmpty;
                    }
                    //
                    //
                    function notify(notificationFunction,m,confirmCallback,validationButton,cancelButton){
                        if(m === CHECK_PRODUCT_LAST_MESSAGE) return;
                        CHECK_PRODUCT_LAST_MESSAGE = m;
                        notificationFunction({
                            title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                            subtitle:m,
                            validation:validationButton,
                            cancel:cancelButton,
                            asyncClose:true,
                        },confirmCallback);
                    }
                    function confirmNotice(m,confirmCallback,validationButton,cancelButton){
                        notify(app.confirm,m,confirmCallback,validationButton,cancelButton)
                    }
                    function alertNotice(m,confirmCallback,validationButton){
                        notify(app.alert,m,confirmCallback,validationButton)
                    }
                    //
                    function afterConfirmProductCrossSellingMissing(confirm,hideConfirm){
                        hideConfirm();
                        var productPageView = new ProductPageView({
                                id_product:firstUnavailableCrossSellingProduct.getProduct().id,
                                cartProduct:firstUnavailableCrossSellingProduct
                            });
                        productPageView.once('close',function(view,closeStateAddToCart){
                            CHECK_PRODUCT_LAST_MESSAGE = false;
                            if(closeStateAddToCart){
                                doCheck();
                            }else{
                                applyErrorCallback();
                            }
                        });
                        app.displayModal(productPageView);
                    }
                    //
                    function afterConfirmProductOfferedMissing(confirm,hideConfirm){
                        if(confirm){
                            // on affiche le selecteur
                            hideConfirm();
                            var modalView = cart.reopenFreeProductChoice(true);
                            cart.listenToOnce(modalView,'close',function(){
                                // on reste en stand by
                                applyErrorCallback();
                                // et on ouvre le panier
                                goCart();
                            });
                        }else{
                            // on supprime le bon et on ouvre le panier
                            cart.removeVoucher(cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id_discount')).done(function(){
                                hideConfirm();
                                // on reste en stand by
                                applyErrorCallback();
                                // et on ouvre le panier
                                goCart();
                            })
                        }
                    }
                    //
                    function afterConfirmProductUnavailable(confirm,hideConfirm){
                        cart.getStore().fetchStockoutProduct(function(){
                            if(confirm){
                                // vérifie et supprime les produits indisponibles
                                cart.removeUnavailableProducts(function(){
                                    hideConfirm();
                                    doCheck();
                                });
                            }else{
                                hideConfirm();
                                applyErrorCallback();//app.go('cart');
                            }
                        },doCheck);
                    }

                    return doCheck();
                },
                getInvalidSidedishes:function(cross_selling_products_errors){
                    //
                    // valide que tous les accompagnements obligatoires sont bien setté
                    //
                    var invalidSidedishes = [];
                    invalidSidedishesProducts = [];
                    function pushInvalid(id_cart_product,id_cross_selling){
                        invalidSidedishesProducts.push(id_cart_product);
                        invalidSidedishes.push({
                            id_cart_product:id_cart_product,
                            id_cross_selling:id_cross_selling
                        });
                    }
                    cart.getProducts().each(function(cartProduct){
                        var product = cartProduct.getProduct(), id_cart_product = cartProduct.id;
                        if(_(cross_selling_products_errors||[]).contains(id_cart_product)){
                            pushInvalid(id_cart_product,false);
                        }else if(product && product.isMenu(true)){
                            cartProduct.getSidedishes().each(function(sidedish){
                                if(sidedish.isRequired() && (!sidedish.validateSelection() || sidedish.isStockout())){
                                    pushInvalid(id_cart_product,sidedish.id);
                                }
                            });
                        }
                    });
                    return invalidSidedishes;
                },
                hasRequiredSidedishes:function(cross_selling_products_errors){
                    return cart.getInvalidSidedishes().length == 0;
                },
                requireSmsConfirmationCode:function(params,callback){
                    app.trigger('openConfirmationCodePromptDialogView',params,callback)
                },
                getVoucher: function () {
                    var vouchers = cart.get('discounts');
                    return _(vouchers);
                },
                // TODO - fonction peut-être inutile / dépréciée
                getSponsorship: function () {
                    // static id_cart_discount "sponsorship"
                    return cart.getVoucher().findWhere({id_cart_discount:'sponsorship'});
                },
                getDiscount: function () {
                    var reduction = cart.get('total_discount');
                    if (_.isUndefined(reduction)) reduction = 0;

                    return formatPrice(reduction);
                },


                formatConsumablesPrice: function () {

                    var price = cart.get('total_price_ttc_consumables');
                    if (price <= 0) {
                        return '';
                    }

                    return formatPrice(price);

                },
                getCagnottage:function () {
                    return this.get('cagnottage');
                },
                getFidelityComponentTheme:function(){
                    var theme = 'theme-default';
                    hooks.execHook('getFidelityComponentTheme',{},function(themeName){
                        theme = themeName;
                    });
                    return theme;
                },
                updateCagnotte:function(){
                    // met à jour la cagnotte pour ne pas dépasser le panier
                    cart.setCagnotte(cart.getCagnotte());
                },
                setCagnotte:function(value){
                    if(!cart.useCagnotte()){
                        value = 0;
                    }else{
                        value = Math.min(app.getCustomer().getCagnotteAmount() || 0,cart.getPriceTTC()/cart.getCagnotteConversionRate(),value || 0);
                    }
                    cart.set('cagnotte',value);
                    cart.updateLocalStorageItem();
                },
                useCagnotte:function(){
                    var useCagnotte = false;
                    hooks.execHook('useCagnotte',cart,function(u){
                        useCagnotte = u;
                    })
                    return useCagnotte;
                },
                getCagnotteConversionRate:function(){
                    return app.getCustomer().getCagnotteConversionRate();
                },
                getCagnotte:function(currencyConversion){
                    if(!cart.useCagnotte()){
                        return 0;
                    }
                    var cagnotte = cart.get('cagnotte') || 0;
                    if(currencyConversion){
                        cagnotte *= app.getCustomer().getCagnotteConversionRate();
                    }
                    return cagnotte;
                },
                formatCagnotteCustomer:function(){
                    return app.getCustomer().displayCagnotteAmount();
                },
                formatCagnotteUsed:function(){
                    // if used, display negative used, else positive available
                    var amountUsed = cart.getCagnotte(),
                        formated;
                    if(amountUsed > 0){
                        formated = formatPrice(-amountUsed); // default formatting
                        hooks.execHook('formatCagnotte',-amountUsed,function(f){
                            formated = f;
                        });
                    }else{
                        formated = cart.formatCagnotteCustomer();
                    }
                    return formated;
                },
                formatEarnCagnotte:function(){
                    return formatPrice((cart.getPriceTTC() - cart.getCagnotte()) * app.c('_COMEIN_RECUP_VALUE_', 5) / 100)
                },
                formatCagnotteSubtitle:function(){
                    var amount = cart.formatCagnotteUsed();
                    return app.t(!app.getCustomer().isLogged() ?
                        'Veuillez vous connecter' : // non connecté
                        amount.includes('-') ?
                            "Montant utilisé %s": // cagnotte utilisée
                            "Saisissez le montant à déduire", // cagnotte disponible
                        "Cart", amount)
                },
                setOrderMessage:function(message){
                    cart.set('order_message',message);
                    cart.updateLocalStorageItem();
                },
                getOrderMessage:function(){
                    return cart.get('order_message') || '';
                },
                formatPriceTotal:function(){
                    var cagnotte = cart.getCagnotte(true);
                    return cart.formatPrice(-cagnotte);
                },
                isZeroTTC:function(){
                    var cagnotte = cart.getCagnotte(true);
                    return cart.getPrice(-cagnotte) === 0;
                },
                getPrice: function (addition) {
                    if (_.isUndefined(addition)) addition = 0;
                    var price = cart.getPriceTTC();
                    if (!_.isNumber(price)) price = 0;
                    var priceAddition = price + addition;

                    priceAddition = priceAddition < 0 ? 0 : priceAddition;

                    if (priceAddition < 0){
                        priceAddition = 0;
                    }

                    return parseFloat(priceAddition);
                },
                formatPrice: function(addition) {
                    return formatPrice(cart.getPrice(addition));
                },
                // pour les fermetures exceptionnelles, on va reporter la date à la réouverture
                reportToNextOpening:function(json,options,store){
                    var report = false;
                    if(json && json.closing_date_end){
                        // fermeture exceptionnelles
                        var closing_date_end = moment(json.closing_date_end),
                            report_recursion = options.report_recursion | 0;
                        report_recursion++;
                        if(!closing_date_end.isValid()){
                            // au cas où la date de closing_date_end soit invalide...
                            app.alert();
                            report = true;
                        }else if(report_recursion<8) {
                            // protège contre les récursions, liées à des erreurs
                            options.report_recursion = report_recursion;
                            //
                            if (report_recursion == 2) {
                                cart.displayUnavailableDatetime(json.error);
                            }
                            if(store) {
                                var availableDatetime = store.findAvailableDatetime(options.vae == 1, closing_date_end.toDate());
                                if (availableDatetime.moment) {
                                    options.now = availableDatetime.now;
                                    report = availableDatetime.moment;
                                }
                            }
                        }else{
                            // si on dépasse les 8 tentatives
                            report = true;
                        }
                    }
                    //
                    // return false | true | moment
                    //
                    return report;
                },
                // options de livraison
                setDeliveryOptions: function (options, deliveryOptions, datetime) {
                    //
                    //
                    // var availableDatetime = store.findAvailableDatetime(options.vae == 1, datetime || cart.getDatetime());
                    //

                    var now = options.now,
                        undefinedTimeOption = _.isUndefined(now);
                    if(undefinedTimeOption){
                        now = cart.get('now') || 1;
                        var targetDatetime = datetime || cart.getDatetime(),
                            targetMoment = moment(targetDatetime);
                        options.now = now;
                        options.order_date = targetMoment.format(CART_DATE_FORMAT);
                        options.order_time = targetMoment.format(CART_TIME_FORMAT);
                    }
                    if(now > 0){
                        delete options.order_date;
                        delete options.order_time;
                    }
                    // options.id_address_delivery = false;
                    //
                    //
                    function setDeliveryOptionsFail(){
                        cart.trigger('setDeliveryOptionsFail',cart);
                    }
                    return cart.ApiRequest('CartDeliveryOptions', options, {id_cart: cart.id})
                        .done(function (data) {
                            // applique les détails des addresses de livraison
                            data.deliveryOptions = _.defaults(deliveryOptions,options);
                            // data.id_address_delivery = data.id_address_delivery;
                            data.id_district = options.id_district;
                            //
                            // si la donnée a disparue adresse de livraison a disparu, il faut la supprimer
                            if(!data.id_address_delivery){
                                data.id_address_delivery = false;
                            }

                            //
                            cart.set(data);
                            cart.trigger('deliveryUpdate', cart);
                            var store = cart.getStore();

                            if(!store){
                                return setDeliveryOptionsFail();
                            }

                            //
                            // TODO ajouter _SMART_REPLACE_POSTAL_CODE_ à update.php
                            //
                            if(app.c('_SMART_REPLACE_POSTAL_CODE_',false) && data.id_address_delivery){
                                var address = cart.getAddressDelivery();
                                if(address){
                                    address.smartReplacePostalCode();
                                }
                            }

                            store.once('sync', function storeFetch() {
                                store.fetchStockoutProduct(function(){
                                    cart.trigger('changeContext', cart);
                                },function(){
                                    app.alert();
                                });
                            });
                            store.fetch();


                            //
                            //
                            // effectue refresh reporté
                            //cart.refresh(true);
                        })
                        .fail(function (response, status, textMessage) {
                            //
                            var json = response.responseJSON || {},
                                title = app.t('Toutes nos excuses !',UI_CONTEXT),
                                subtitle = json.error,
                                type = json.type,
                                next_opening = json.next_opening,
                                reportDateTime;

                            if(type === 'store_closed'){
                                // fermeture exceptionnelles
                                app.alert({
                                    title:title,
                                    subtitle: subtitle+'<div class="alert-info"><pre>'+JSON.stringify(json,null,2)+'</pre></div>',
                                    template: 'sorry'
                                },function(){
                                    var nextOptions = _.defaults({},next_opening,options);
                                    cart.setDeliveryOptions(nextOptions,deliveryOptions);
                                })
                                return;
                            }else if(type === 'require_next_opening'){
                                // si on reporte, on fait une autre tentative et on affiche pas d'erreur
                                var nextMoment = moment(next_opening.order_date+' '+next_opening.order_time);
                                title = app.t(UI_WARNING_TEXT,UI_CONTEXT);
                                subtitle += ', '+
                                    app.t('votre commande sera prise pour la prochaine date d’ouverture disponible, %s','AddressAutocomplete',nextMoment.calendar());
                                app.confirm({
                                    title:title,
                                    subtitle:subtitle
                                },function(confirm){
                                    var nextOptions = _.defaults({},next_opening,options);
                                    if (confirm){
                                        cart.setDeliveryOptions(nextOptions,deliveryOptions);
                                    } else {
                                        setDeliveryOptionsFail();
                                    }
                                });
                                return
                            }else if(type === 'store_exceptional_closed'){
                                var post_alert_action = json.post_alert_action;
                                if(post_alert_action>0){
                                    var post_alert_action_label = app.t([
                                        '',
                                        'Différer',
                                        'Passer en livraison',
                                        'Passer en Click & Collect',
                                    ][post_alert_action],'Checkout')
                                    app.confirm({
                                        title:title,
                                        subtitle:subtitle,
                                        validation:post_alert_action_label,
                                        template: 'sorry'
                                    },function(confirm){
                                        if(confirm){
                                            if(post_alert_action === 1){
                                                var nextOptions = _.defaults({},next_opening,options);
                                                cart.setDeliveryOptions(nextOptions,deliveryOptions);
                                            }else if(post_alert_action === 2){
                                                // passer en VAD
                                                app.trigger('toggleAddressAutocompleteType','address');
                                            }else if (post_alert_action === 3){
                                                // passer en VAE
                                                var id_store = json.id_store;
                                                cart.setDeliveryOptions({
                                                    id_store:id_store,
                                                    now:options.now,
                                                    vae:1,
                                                    order_date:options.order_date,
                                                    order_time:options.order_time,
                                                }, {});
                                            }
                                        }
                                        setDeliveryOptionsFail();
                                    });
                                    return;
                                }
                            }else{
                                app.error('CartDeliveryOptionsError',{status:status,json:json,options:options,deliveryOptions:deliveryOptions});
                            }
                            var message = status;
                            try{
                                message = json.error;
                            }catch(err){
                                if(textMessage){
                                    message += ' : ' + textMessage;
                                }
                            }
                            app.alert({title:title,subtitle:message, template: 'sorry'});
                            setDeliveryOptionsFail();
                        })
                    // }


                }, //
                updateDeliveryOptions:function(attr){
                    _.extend(cart.get('deliveryOptions'),attr)
                },
                refreshDeliveryOptions: function (order_date, order_time) {
                    var options = _(cart.pick('vae','now','id_store','id_postcode','id_district'));

                    options.order_date = order_date;
                    options.order_time = order_time;

                    cart.setDeliveryOptions(options, cart.getDeliveryOptions());
                }, //
                switchToVAE: function () {
                    var deliveryOptions = cart.getDeliveryOptions(), options = {
                        vae: 1, id_store: cart.getStore().id,
                    };
                    cart.setDeliveryOptions(options, deliveryOptions);
                }, //
                switchToVAD: function () {
                    var deliveryOptions = cart.getDeliveryOptions();
                    // si on a pas d'historique local, impossible de switcher en VAD
                    if ((!deliveryOptions) || // ou si l'historique est un VAD, il faut demander la saisie d'une addresse
                        (deliveryOptions.type === 'store')) {
                        return cart.requireDeliveryOptions('address');
                    }
                    //
                    var failure = false,
                        place = PlaceModel.getPlace(deliveryOptions.place_id),
                        address = app.getAddress(deliveryOptions.id_address),
                        id_store = cart.getStore().id,
                        options = {
                            vae: 0,
                            id_store: id_store
                        };
                    if(place && !address){
                        address = app.getAddresses().createAddressFromPlace(place);
                    }
                    if (address) {
                        //options.id_address_delivery = address.id;
                        var addressOptions = address.formatAddressOptions();
                        options = addressOptions.options;
                        deliveryOptions = _.defaults(addressOptions.deliveryOptions,deliveryOptions);
                    } else {
                        // si on a pas de place_id clairement identifié,
                        // on concidère que l'utilisateur devra resaisir son adresse dans le moteur d'adresse
                        failure = true;
                    }
                    if(failure){
                        return cart.requireDeliveryOptions('address');
                    }
                    cart.setDeliveryOptions(options, deliveryOptions);
                },
                validateDeliveryAddress: function () {
                    // cette méthode valide, et créé, à partir des options de livraison,
                    // une adresse, qui sera affecté au client plus tard

                    var deliveryOptions = cart.getDeliveryOptions();

                    if (cart.isVAE() || cart.getAddressDelivery() || _.isNull(deliveryOptions)) return true;

                    var place = PlaceModel.getPlace(deliveryOptions.place_id);

                    if (_.isUndefined(place)) return false;

                    app.getAddresses().createAddressFromPlace(place, 1);
                }, //
                formatStoreName: function () {
                    var store = cart.getStore();
                    if (store) {
                        return store.getFullName();
                    }
                }, //
                formatStoreAddress: function () {
                    var store = cart.getStore();
                    if (store) {
                        return store.formatAddress();
                    }
                }, //
                displayNoDeliveryOptions:function(){
                  return app.t('Merci de renseigner votre adresse de livraison ou votre shop de retrait afin d’afficher la carte de votre Shop', CART_TRANSLATION_CONTEXT)
                },
                localAndRemoteFetch: function () {
                    // override LocalStorage.localAndRemoteFetch
                    cart.localFetch();
                    cart.refresh();
                }, //
                refresh: function (reportRefresh) {
                    //
                    // use remoteFetch function, including refreshTimeout
                    //
                    var refresh = _.isUndefined(reportRefresh);

                    clearTimeout(cartRefreshTimeout);
                    if (refresh) {
                        // force l'actualisation
                        cart.remoteFetch();
                    }
                    var cartRefreshDelay = cart.getRefreshDelay();
                    if(cartRefreshDelay>0){
                        cartRefreshTimeout = setTimeout($.proxy(cart.refresh, cart), cart.getRefreshDelay());
                    }
                },
                getRefreshDelay: function (max) {
                    //
                    // retourne le délai pour le prochain rafraichissement
                    //
                    var refreshDelay = 0, now = cart.get('now'),
                        min = HOUR_IN_MS * 2; // maximum 2 heures
                    max = max ? max : MINUTE_IN_MS; // minimum 1 minute
                    switch (now) {
                        // différé
                        default :
                        case -1:
                        case 0:
                            refreshDelay = cart.getDatetimeMoment().subtract(15, 'minutes').diff();
                            // à l'échéance, moins 15 minutes
                            break;

                        // maintenant
                        case 1:
                            refreshDelay = 15 * MINUTE_IN_MS;
                        // toutes les 15 minutes, réinitialisé en cas de mise à jour
                    }
                    if(_.isNaN(refreshDelay)){
                        refreshDelay = max;
                    }
                    if (refreshDelay < 0) {
                        cart.trigger('datetimePassed');
                    }
                    // http://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
                    return Math.min(min, Math.max(max, refreshDelay));
                }, //

                //
                // demande un nouveau panier à partir d'un id_order
                //
                reorder:function(order){
                    var id_parent_cart = order.get('id_cart');
                    return cart.ApiRequest('CartReorder',{
                        validate_partial:0,
                        validate_empty:0
                    },{
                        id_parent_cart:id_parent_cart,
                        id_cart:cart.id,
                    }).done(function(data){
                        //
                        //
                        //
                        delete data.id_cart;
                        cart.set(data);
                        cart.unset('reorderFail');
                        if(!cart.isVAE()){
                            var customerAddress = cart.getAddressDelivery();
                            if(customerAddress){
                                try{
                                    var options = customerAddress.formatAddressOptions(cart.getDatetime(),cart.get('id_store'));
                                    cart.set('deliveryOptions',options.deliveryOptions);
                                }catch(err){
                                    cart.unset('deliveryOptions');
                                    cart.set('reorderFail','unavailableAddress');
                                }
                            }else{
                                cart.unset('deliveryOptions');
                            }
                        }
                        function checkMissingProducts(){
                            var initial_products_ids = order.get('products'),
                                cart_products = _(cart.get('products')).pluck('id_product'),
                                diff = _.difference(initial_products_ids,cart_products);
                            return diff.length > 0;
                        }
                        var label_order_ready_title = 'Votre commande est prête !',
                            validationLabel = app.t('Ok','UI'),
                            title = app.t(label_order_ready_title,'Reorder');
                        function checkRequiredSidedishes(){
                            var hasRequiredSidedishes = cart.hasRequiredSidedishes();
                            if(!hasRequiredSidedishes){
                                // formules avec accompagnements obligatoires
                                // on alerte
                                var subtitle = app.t('Cependant, certaines formules sont à compléter','Reorder');
                                if(checkMissingProducts()){
                                    subtitle = app.t('Cependant, certaines formules sont à compléter et des produits ne sont actuellement plus disponibles.','Reorder');
                                }
                                app.alert(
                                    {
                                        title:title,
                                        subtitle:subtitle,
                                        validation:validationLabel,
                                    },
                                    function(){
                                        // puis on va sur le panier
                                        app.go('cart');
                                        var cartProduct = cart.getProduct(invalidSidedishesProducts[0]);
                                        // et on affiche la formule avec accompagnement indisponible
                                        app.displayModal(
                                            new ProductPageView({
                                                id_product:cartProduct.getProduct().id,
                                                cartProduct:cartProduct
                                            })
                                        );
                                    }
                                );
                            }
                            return hasRequiredSidedishes;
                        }
                        if (checkRequiredSidedishes()) {
                            // si pas de formule impactée
                            if(checkMissingProducts()) {
                                // mais qu'il manque des produits, on alerte
                                app.alert(
                                    {
                                        title: title,
                                        subtitle: app.t('Cependant, des produits ne sont actuellement plus disponibles.', 'Reorder'),
                                        validation: validationLabel,
                                    },
                                    function () {
                                        app.go('cart');
                                    }
                                );
                            }else{
                                // sinon, quand tout va bien, on redirige vers le panier, sans prévenir
                                app.go('cart');
                            }
                        }
                        cart.trigger('reorder');
                    }).fail(function(res,status){
                        var responseJSON = res ? res.responseJSON : false,
                            errMessage =  responseJSON ? (responseJSON.error || responseJSON.message) : false;
                        if(errMessage){
                            app.alert(errMessage);
                            //cart.set('reorderFail','unkwown');
                        }else{
                            app.alert();
                        }
                        cart.trigger('reorder');
                    })
                },
                addToCartReorder:function(id_parent_cart){
                    cart.ApiRequest('CartAddToCart',null,{
                        id_parent_cart:id_parent_cart,
                        id_cart:"virtual"
                    }).done(function(data){
                        //
                        //
                        //
                        cart.set(data);
                        app.getCart().remoteFetch().done(function(){
                            cart.trigger('addToCartReorder');
                        });
                    }).fail(function(){
                        app.alert();
                    })
                },
                //
                // transforme un panier en panier principal
                //
                setCurrent:function(){
                    return cart.ApiRequest('CartSetCurrent',null,{id_cart:cart.id}).done(function(data){
                        //
                        var currentCart = app.getCart();
                        data.id_cart = 'current';
                        function Sync(){
                            var deliveryOptions = cart.getDeliveryOptions();
                            currentCart.set('deliveryOptions',deliveryOptions);
                            cart.trigger('setCurrent');
                        }
                        currentCart.once('sync',Sync);
                        currentCart.remoteFetch();
                        //
                    }).fail(function(){
                        app.alert();
                    });
                },

                reset:function(data){
                    cart.clear();
                    cart.set(data);
                    cart.setLocalStorageItem();
                },

                resetPreset:function() {

                    cart.ApiRequest('CartConsumableReset', null, {id_cart: cart.id})
                        .done(function (data) {
                            cart.set(data);

                            cart.trigger('resetpreset', cart);
                        })
                        .fail(function (xhr, status, errorType) {
                            app.alert();
                        })
                },
                setDeliveryDatetime: function (date, time, now) {
                    // TODO now value
                    var options = {order_date: date, order_time: time, now: now},
                        store = cart.getStore();
                    if (store.hasDistricts()) {
                        options.id_district = cart.get('id_district');
                    }

                    function SetDeliveryDatetime(options) {
                        return cart.ApiRequest('CartDatetime', options, {id_cart: cart.id})
                            .done(function (data) {
                                cart.set(data);
                                cart.updateLocalStorageItem();
                                cart.trigger('deliveryUpdate', cart);
                                cart.trigger('changeContext', cart);
                            })
                            .fail(function (xhr, status, errorType) {
                                options.vae = cart.get('vae');
                                var json = xhr.responseJSON, err,
                                    reportDateTime = cart.reportToNextOpening(json, options, store);

                                if (reportDateTime) {
                                    if (reportDateTime !== true) { // non  dépassement des récursions
                                        options.order_date = reportDateTime.format(CART_DATE_FORMAT);
                                        options.order_time = reportDateTime.format(CART_TIME_FORMAT);
                                        cart.displayUnavailableDatetime(json.error, function () {
                                            SetDeliveryDatetime(options);
                                        });
                                    }
                                    return;
                                }

                                cart.trigger('setDeliveryOptionsFail', cart);
                                if (json && json.error) {
                                    err = {title: errorType, subtitle: xhr.responseJSON.error, template: 'sorry'};
                                }
                                app.alert(err);
                            })
                    }
                    return SetDeliveryDatetime(options);
                },
                displayUnavailableDatetime:function(details, callback){
                    var subtitle = details+'<br/><small>'+app.t('Votre commande va être basculée sur le prochain créneau disponible.', CART_TRANSLATION_CONTEXT)+'</small>';
                    app.alert({title: app.t('Fermeture exceptionnelle',CART_TRANSLATION_CONTEXT), subtitle: subtitle, template: 'sorry', callback:callback});
                },
                getProductOfferedCartProduct: function(){
                    var id_cart_product = this.getProductOffered();
                    if(id_cart_product) return cart.getProduct(id_cart_product);
                },
                getProductOffered:function () {
                  var product_offered_id = false,
                      true_id = cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'true_id'),
                      id = cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id');
                  if (true_id &&  id != "0-0" && id != "0")
                  {
                      product_offered_id = true_id;
                  }
                  if(product_offered_id == '0' || product_offered_id == '0-0'){
                      product_offered_id = false;
                  }
                  return product_offered_id
                },
                getProductOfferedId:function () {
                    var pattern = /^(\d+)-?.*/,
                        free_product_id_true_or_not_true = cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id') || cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'true_id');
                    if (free_product_id_true_or_not_true && pattern.test(free_product_id_true_or_not_true))
                    {
                        return pattern.exec(free_product_id_true_or_not_true)[1];
                    }else{

                        return false;
                    }
                },
                hasProductOfferedSelected:function(){
                    var getProductOffered = cart.getProductOffered();
                    return !(getProductOffered == false || getProductOffered == "0-0" || getProductOffered == '0');
                },
                getStore: function () {
                    return app.getStore(cart.get('id_store'));
                },
                getCustomer: function () {
                    return app.getCustomer();
                },
                getDeliveryOption: function (key) {
                    var deliveryOptions = cart.get('deliveryOptions');
                    if ((deliveryOptions == null) || _.isUndefined(deliveryOptions[key])) {
                        return '';
                    } else {
                        return deliveryOptions[key];
                    }
                },
                getDistrictId:function() {
                    var d = cart.get('id_district');
                    if(d && d!='0') return d;
                },
                getPostcodeId:function() {
                    var p = cart.get('id_postcode');
                    if(p && p!='0') return p;
                },
                requireAddressAlias:function(){
                    var addressDelivery = cart.getTemporaryAddress(),
                        requireAddressAlias = cart.isVAD();
                    if(requireAddressAlias && addressDelivery) {
                        var alias = addressDelivery.getAlias(),
                            type = addressDelivery.get('type');
                        requireAddressAlias = !((type > 0) || !!alias);
                    }
                    return requireAddressAlias;
                },
                getAddressIcon:function(){
                    var addressDelivery = cart.getAddressDelivery();
                    return addressDelivery.getIcon();
                },
                getAddressWithAlias:function(){
                    var addressDelivery = cart.getTemporaryAddress(),
                        displayAddress = cart.getDisplayAddress();
                    if(addressDelivery && cart.isVAD()) {
                        var alias = addressDelivery.getAlias(),
                            icon = addressDelivery.getIcon(),
                            iconHtml = '<i class="icon-' + icon + '"></i>',
                            addressLiteralHtml = '<span class="address-literal">' + displayAddress + '</span>';
                        if (!!alias) {
                            displayAddress = iconHtml+ '<span class="address-alias" data-cs-mask>' + addressDelivery.formatAliasLabel() + ',</span> '+addressLiteralHtml
                        }else{
                            displayAddress = addressLiteralHtml;
                        }
                    }
                    return displayAddress;
                },
                getDisplayAddress: function (reorder) {
                    var store = cart.getStore();
                    if (store) {
                        if (cart.isVAE()) {
                            return cart.getStore().getName()
                        }
                        var address = cart.getAddressDelivery();
                        if (address) {
                            return address.formatAliasStreetAddress(false, reorder);
                        }
                        var description = cart.getDeliveryOption('description');
                        //
                        if(!description){
                            description = app.t('Votre adresse n’a pu être déterminée.',CART_TRANSLATION_CONTEXT);
                        }
                        return description;
                    } else {
                        return t('Saisissez votre adresse de livraison ou votre shop', CART_TRANSLATION_CONTEXT);
                    }
                }, // retourne une phrase indiquant le moment de livraison
                formatDeliveryTimeLabel: function (deliveryDelayFormat) {
                    // TODO peux mieux faire
                    return cart.isNow() ?
                        cart.formatDeliveryDelay(deliveryDelayFormat) :
                        cart.getDatetimeMoment().calendar(new Date(), momentFormats.getFormats());
                },
                // retourne une phrase indiquant le type de livraison
                formatDeliveryTypeLabel:function(){
                    return t(this.isVAE() ? 'À venir chercher' : 'Livraison prévue', CART_TRANSLATION_CONTEXT);
                },
                useAdvantages:function(){
                    return app.c('_USE_ADVANTAGES_',1)==1;
                },
                getTemporaryAddress: function(){
                    // instancie une adresse temporaire
                    // hors du carnet d'adresse
                    // afin d'avoir des fonctions de formatage dans la partie checkout address
                    var place = cart.getPlace(),
                        address = cart.getAddressDelivery();
                    if(!address && place){
                        address = AddressModel.createAddressFromPlace(place,1,0,0,cart.getDeliveryOption('source'));
                    }
                    if(!!address){
                        address.set('attach_to_cart',1);
                    }
                    return address;
                },
                // alias de la fonction statique "requireDeliveryOptions", sur une instance panier
                requireDeliveryOptions: function (type,force,callback,options) {
                    return CartModelModule.requireDeliveryOptions(type,cart,force,callback,options);
                },
                //
                removeVoucher: function (id_cart_discount) {
                    return cart.ApiRequest('CartVoucherRemove', {id_cart_discount: id_cart_discount}, {id_cart: cart.id})
                        .done(function (data) {
                            if (!data.discounts) {
                                cart.unset('discounts');
                                cart.unset('total_discount');
                            }
                            cart.set(data);
                            cart.updateLocalStorageItem();
                            app.trigger('cancelVoucher');
                        })
                        .fail(function (xhr, status, errorType) {
                            app.alert();
                        })
                },
                addVoucher: function (voucherCode) {
                    return cart.ApiRequest('CartVoucherAdd', {discount_name: voucherCode}, {id_cart: cart.id})
                        .done(function (data) {
                            cart.set(data);
                            cart.updateLocalStorageItem();
                            var discounts = cart.get('discounts');

                            var displayModal = false;

                            _(discounts).each(function(dd){
                                if ((voucherCode.toUpperCase() === dd.name.toUpperCase()) && dd.force_cart_apear === '1'){

                                    cart.unset(FAVORITE_PRODUCT_OFFERED_PREFIX+'id');
                                    cart.unset(FAVORITE_PRODUCT_OFFERED_PREFIX+'true_id');
                                    // affiche la fenetre de selection de produit offert
                                    displayModal = true;
                                    var modalView = new FreeProductChoiceVoucherView({
                                        voucher:dd
                                    });
                                    app.displayModal(modalView);

                                }
                            });
                            if(!displayModal){
                                // le nombre de bon est limité à 1 par panier
                                _(discounts).each(function(dd){
                                    if (voucherCode.toUpperCase() === dd.name.toUpperCase()){
                                        app.alert({
                                            title:app.t("Le code offre %s est appliqué", CART_TRANSLATION_CONTEXT, voucherCode),
                                            subtitle:dd.description,
                                        })
                                    }
                                });

                                //app.banNotice(t('Votre coupon a été ajouté !', CART_TRANSLATION_CONTEXT));
                                app.trigger('addVoucher');
                            }
                        })
                        .fail(function (xhr, status, errorType) {
                            if(xhr.responseJSON && xhr.responseJSON.error){
                                app.alert({
                                    title: app.t('Désolé',UI_CONTEXT),
                                    subtitle:xhr.responseJSON.error
                                });
                            }else{
                                app.alert();
                            }
                            app.trigger('cancelVoucher');
                        })
                },
                getFavoriteProductDiscount:function(){
                    var favorite_product_offored_id_discount = cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id_discount')
                    if(favorite_product_offored_id_discount){
                        var discounts = cart.get('discounts');
                        return _(discounts).find(function(discount){
                            return favorite_product_offored_id_discount == discount.id_cart_discount;
                        });
                    }
                },
                reopenFreeProductChoice:function(force){
                    var modalView = null, discount = cart.getFavoriteProductDiscount();
                    if(discount && (discount.force_cart_apear === '1'||force)){
                        modalView = new FreeProductChoiceVoucherView({
                            voucher:discount
                        });
                        app.displayModal(modalView);
                    }
                    return modalView;
                },
                isFreeProductSelectionRequired:function(){
                    var productCanBeOffered = cart.productCanBeOffered(),
                        freeProductSelectionRequired = productCanBeOffered && !cart.hasProductOfferedSelected();
                    return freeProductSelectionRequired;
                },
                //
                getUsableAdvantages:function(){
                    return app.getCustomer().getUsableAdvantages(false,true);
                },//
                //
                usePaymentMethod: function (pm) {
                    paymentMethod = pm;
                },
                usePaymentMode: function (pm) {
                    paymentMode = pm;
                },
                requireAuthentification:function(callback,confirmBefore){
                    var logged = isLogged();
                    function isLogged(){
                        return app.getCustomer().isLogged();
                    }
                    function complete(){
                        callback(isLogged());
                    }
                    if(!logged){
                        function displayModal() {
                            var authentificationPageView = new AuthentificationPageView({
                                register: true,
                                newsletter: false,
                                comeinId: false,
                                flagcomin: false,
                                isComein: false,
                            });
                            authentificationPageView.trackPageView();
                            authentificationPageView.once('close', complete);
                            app.displayModal(authentificationPageView);
                        }
                        if(confirmBefore){
                            app.confirm({title:app.t(UI_WARNING_TEXT,UI_CONTEXT),subtitle:confirmBefore},function(confirm){
                                if(confirm){
                                    displayModal();
                                }
                            })
                        }else{
                            displayModal();
                        }
                    }else if(callback){
                        complete();
                    }
                    return !logged;
                },
                hasCheckOfferedProducts:function(){
                    //
                    // vérifie
                    // si les produits offerts ont changés,
                    // ou n'ont jamais été vu
                    //
                    var currentCheckSum = cart.get('offeredProductsCheckSum'),
                        newCheckSum = '';
                    cart.getOfferedProducts().each(function(offeredProduct){
                        newCheckSum += offeredProduct.id+'_'+offeredProduct.getQuantity()+'+';
                    });
                    cart.set({offeredProductsCheckSum:newCheckSum},{silent:true});
                    return currentCheckSum==newCheckSum;
                },
                hasCheckDeliveryAddressData:function(address){
                    //
                    // vérifie
                    // si l'adresse à changée,
                    //
                    var data = address.getData(),
                        currentCheckSum = cart.get('deliveryAddressDataCheckSum'),
                        newCheckSum = address.id+':'+address.get('place_id')+':'+data,
                        requireCheck = !data,
                        hasCheck = (!requireCheck) || (currentCheckSum===newCheckSum);
                    cart.set({deliveryAddressDataCheckSum:newCheckSum},{silent:true});
                    return hasCheck;
                },

                hasAllSidedishes:function(){
                    var hasDessert = cart.hasProductOfCategorySlug('dessert'),
                        hasDrink = cart.hasProductOfCategorySlug('drink'),
                        hasSidedish = cart.hasProductOfCategorySlug('sidedish');
                    return hasDrink && hasDessert && hasSidedish;
                },

                requireCrossLinks:function(ignoreCrosslink){
                    //
                    if(ignoreCrosslink === true) return false;
                    //
                    var requireCrossSellingTab = [];
                    hooks.execHook('requireCrossSellingTab',{},function(r){
                        requireCrossSellingTab.push(r);
                    });

                    var
                        hasCheckedOfferedProduct = cart.hasCheckOfferedProducts(),
                        hasCheckedAllExtraTab = !_(requireCrossSellingTab).contains(true),
                        hasAllSidedishes = cart.hasAllSidedishes(),
                        requireCrossLinks = !(hasAllSidedishes && hasCheckedOfferedProduct && hasCheckedAllExtraTab) && (ignoreCrosslink!==true);
                    return requireCrossLinks;
                },
                validateSubmitToCheckout: function(ignoreCrosslink){
                    // effectue une validation
                    // avant la redirection vers la page checkout
                    function revalidate(forceIgnore){
                        cart.validateSubmitToCheckout(ignoreCrosslink || forceIgnore);
                    }

                    if(!cart.validateDeliveryOptions()) {
                        // vérifie le mode de livraison
                        cart.alertDeliveryOptions();
                    }else  if (cart.productCanBeOffered() && !cart.hasProductOfferedSelected())
                    {

                        //
                        // si le processus a été interompu, on lui redemande
                        //
                        cart.confirmFreeProductVoucher(function(){
                            cart.goToCheckout('cart');
                        });

                    } else if(!cart.hasRequiredSidedishes()) {
                        // formules avec accompagnements obligatoires
                        cart.alertRequiredSidedishes();
                    }else if(!cart.hasMinimumPrice()){
                        // prix minimum requis
                        cart.alertMinimumPrice();
                    }else{
                        // ok !
                        cart.goToCheckout('cart');
                    }
                },
                confirmFreeProductVoucher:function(callback){
                    app.confirm({
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t( "Merci de choisir votre produit préféré", CART_TRANSLATION_CONTEXT),
                        cancel:app.t('Ignorer',UI_CONTEXT)
                    },function(success){
                        if(success){
                            // on affiche le selecteur
                            var modalView = cart.reopenFreeProductChoice();
                            cart.listenToOnce(modalView,'close',callback);
                        }else{
                            // on supprime le bon et on ouvre le panier
                            cart.removeVoucher(cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id_discount')).done(callback)
                        }
                    });
                },
                confirmFreeProductVoucherAmount:function(callback){
                    app.alert({
                        title:app.t(UI_WARNING_TEXT,UI_CONTEXT),
                        subtitle:app.t( "Votre coupon produit préféré n'est plus valide et va être retiré de votre panier car vous ne remplissez pas les conditions d'utilisation.", CART_TRANSLATION_CONTEXT),
                      //  cancel:app.t('Ignorer',UI_CONTEXT)
                    });
                    cart.removeVoucher(cart.get(FAVORITE_PRODUCT_OFFERED_PREFIX+'id_discount'));
                    callback();
                    cart.goToCheckout('cart');

                },
                submitToCheckout: function(ignoreCrosslink){
                    // cette méthode sert à soumettre un panier pour être redirigé vers le checkout
                    // est-ce que les sauces ont été revues
                    cart.goToCheckout('payment');
                },
                goToCheckout:function(idStep){
                    idStep = idStep || 'cart';
                    app.go('checkoutOpc',CheckoutModel.getStep(idStep));
                },

                removeUnavailableProducts:function(callback) {
                    cart.removeProducts(callback,cart.getProductsIndispo());
                },
                removeProducts:function(callback,collection){
                    // supprime tous les produits indisponibles
                    if(!collection) collection = cartProductCollection
                    function deleteProducts(){
                      var productToDelete = collection.at(0);
                      if(productToDelete) {
                          cart.deleteProduct(productToDelete.id).done(function () {
                              deleteProducts();
                          })
                      }else{
                          callback();
                      }
                    }
                    deleteProducts();
                },

                updateProductPaymentRestrictions:function(){

                    // met à jour les restrictions produits
                    var payment_restrictions = {},

                        // la sum permet de détecter rapidement les changements réels de restriction
                        // on a un évenement change:payment_restrictions_sum
                        // dans CheckoutPaymentMethodView afin d’optimiser les cas généraux
                        payment_restrictions_sum = '',
                        cartPaymentModes = cart.getPaymentModes(),
                        cartPaymentModesIds = cartPaymentModes.pluck('id_payment_mode'),
                        availablePaymentModes = 0;

                    function testProductPaymentRestrictions(product,ignore_if_empty){
                        if (product && product.hasPaymentRestriction()){
                            _(product.getPaymentRestriction()).each(function(r){

                                var id_payment_mode = r.id_payment_mode,
                                    force_if_empty = r.force_if_empty,
                                    restrictions = payment_restrictions[id_payment_mode],
                                    restriction = product.id;

                                // gestion du cas exceptionnel "force_if_empty"
                                if(ignore_if_empty && force_if_empty) return;

                                if(restrictions){
                                    // si la méthode a déjà des restrictions, on ajoute le produit
                                    restrictions.push(restriction);
                                }else{
                                    // si la méthode n'a pas encore de restriction, on l'ajoute
                                    restrictions = payment_restrictions[id_payment_mode] = [restriction];
                                }
                                var paymentMode = cart.getPaymentMode(id_payment_mode);
                                if(paymentMode){
                                    paymentMode.set('restrictions',restrictions);
                                    payment_restrictions_sum += '/'+id_payment_mode+':'+product.id;
                                }
                            });
                        }
                    }

                    function testCartProductsPaymentRestrictions(ignore_if_empty){

                        payment_restrictions = {};
                        payment_restrictions_sum = '';
                        ignore_if_empty = ignore_if_empty === true;

                        // pour tous les produits du paiment
                        cart.getProducts().each(function(cartProduct) {
                            var product = cartProduct.getProduct();
                            // on vérifie les restrictions du produit
                            testProductPaymentRestrictions(product,ignore_if_empty);
                            // et de ses accompagnements
                            cartProduct.getAccompagnement().each(function(accompagnement) {
                                testProductPaymentRestrictions(accompagnement.getProduct(),ignore_if_empty);
                            });
                         });

                        var restrictionModesIds = _(payment_restrictions).keys();
                        availablePaymentModes = _.difference(cartPaymentModesIds,restrictionModesIds).length;
                    }

                    // test initial
                    testCartProductsPaymentRestrictions(false);
                    //

                    if(availablePaymentModes == 0){
                        // pour le cas exceptionnel ou les restrictions produits bloque tous les modes de paiment
                        // on rejoue le test en "ignore_if_empty"
                        testCartProductsPaymentRestrictions(true);
                    }


                    cart.set({
                        payment_restrictions:payment_restrictions,
                        payment_restrictions_sum:payment_restrictions_sum
                    });
                },

                getPaymentGroups:function(inContext){
                    // TODO in Context
                    var store = cart.getStore(),
                        paymentGroups = (store ? store.getPaymentGroups() : false);
                    return paymentGroups ? paymentGroups : app.getPaymentGroups();
                },
                getPaymentMethods:function(inContext){
                    var store = cart.getStore(),
                        paymentMethods = (store ? store.getPaymentMethods() : false);
                    var paymentMethodCollection = paymentMethods ? paymentMethods : app.getPaymentMethods();
                    if(inContext !== false){
                        var isVAE = cart.isVAE(), filter = {};
                        filter[isVAE?'vae':'vad'] = true;
                        return new PaymentMethodCollection(paymentMethodCollection.filter(filter));
                    }
                    return paymentMethodCollection;
                },
                getPaymentMethod:function(id_payment_method){
                    return cart.getPaymentMethods().findWhere({id_payment_method: id_payment_method.toString()});
                },

                getPaymentModes:function(){
                    var store = cart.getStore(),
                        paymentModes = (store ? store.getPaymentModes() : false);
                    return paymentModes ? paymentModes : app.getPaymentModes();
                },
                getPaymentMode:function(id_payment_mode){
                    return cart.getPaymentGroups().getPaymentMode(id_payment_mode);
                },
                getUsedPaymentMode:function(){
                    return paymentMode;
                },
                flush:function(){
                    cart.resetLocalStorageItem();
                },
                requireCVC:function(){
                    // Ogone CVC display rules :
                    // Total price > 100€ OR
                    // Address never used OR never Store used
                    var cart = this, isVAE = cart.isVAE(), requireCVC = true;
                    if(cart.getPriceTTC()<app.c('_CVC_CART_MIN_DISPLAY_',100)){
                        var customer = app.getCustomer(), store = cart.getStore();
                        if(store){
                            if(isVAE){
                                // si l'utilisateur a déjà commandé dans cette boutique
                                requireCVC = !_(customer.get('orders_stores')).contains(store.id);
                            }else{
                                // si l'utilisateura déjà commandé à cette adresse
                                var deliveryAddress = cart.getAddressDelivery();
                                if(deliveryAddress)
                                    requireCVC = !_(customer.get('orders_addresses')).contains(deliveryAddress.id);
                            }
                            // si la boutique est en 3DS obligatoire
                            if(store.get('force_card_security')){
                                requireCVC = true;
                            }
                        }
                    }
                    return requireCVC;
                },
                doPaymentCall: function (orderOptions, callback) {

                    var errorMessage = {
                        title: t('Sécurité', UI_CONTEXT),
                        subtitle: t('Une erreur est survenue sur votre paiement', 'Payment') // erreur par défaut
                    };

                    function triggerError(errorMessage){
                        cart.trigger('doPaymentError');
                        if(!!errorMessage) app.alert(errorMessage)
                    }

                    function RecaptchaRetryOrder(){
                        ReCaptcha("order", function (token) {
                            //worf
                            orderOptions.token = token;
                            cart.doPaymentCall(orderOptions,callback);
                        }, function (err) {
                            triggerError(app.t('Une erreur est survenue, liée à ReCaptcha, vérifiez peut-être votre logiciel antipub.','Account'));
                            app.error('ReCaptchaError',err);
                        })
                    }

                    return cart.ApiRequest('ToolsPaymentMethod', orderOptions, {
                        method: 'doPayment', id_cart: cart.id
                    })
                        .done(function (data,status,jqXHR) {
                            var status = data.status;
                            if (data.error) {
                                errorMessage.subtitle = data.error;
                            }
                            if (status == 1) {
                                cart.flush();
                                window.location = data.redirect;
                                return;
                            } else if (status == 0) {
                                // noop
                            } else if (status <= -1) {
                                if (data.type) {
                                    switch (data.type) {
                                        case 'NeedRecaptcha':
                                            RecaptchaRetryOrder()
                                            return;
                                        case 'AcceptSmsConfirmationCode':
                                            errorMessage.cancel = app.t('Modifier',UI_CONTEXT)
                                            app.confirm(errorMessage,function(confirm){
                                                if(confirm){
                                                    orderOptions.sms_accept = 1;
                                                    RecaptchaRetryOrder();
                                                }else{
                                                    triggerError();
                                                }
                                            })
                                            return;
                                        case 'InvalidSmsConfirmationCode':
                                        case 'NeedSmsConfirmationCode':

                                            function RequireSmsConfirmation(){
                                                cart.requireSmsConfirmationCode(_.defaults({},errorMessage,data),function(sms_code,requireNewCode){
                                                    if(requireNewCode){
                                                        delete orderOptions.sms_accept;
                                                        delete orderOptions.sms_code;
                                                        RecaptchaRetryOrder();
                                                    }else if(!sms_code){
                                                        triggerError();
                                                    }else{
                                                        orderOptions.sms_code = sms_code
                                                        RecaptchaRetryOrder();
                                                    }
                                                })
                                            }
                                            if(data.new_code_available){
                                                // en cas d'échec multiple, on relance un nouveau code
                                                app.confirm(errorMessage,function(confirm){
                                                    if(confirm){
                                                        delete orderOptions.sms_code;
                                                        errorMessage.subtitle = data.error;
                                                        RequireSmsConfirmation();
                                                    }else{
                                                        triggerError();
                                                    }
                                                })
                                            }else{
                                                RequireSmsConfirmation();
                                            }

                                            return;
                                        case 'SubmitForm':
                                            return app.trigger('submitForm', data.form);
                                        case 'Redirect' :
                                            return  window.location = data.redirect;
                                        case 'Print' :
                                            return app.$body.append(atob(data.print.content));
                                        case 'IframeOgoneDirect':
                                            if(callback) callback();
                                            return app.trigger('IframeOgoneDirect',data);
                                        case 'CrossSellingError':
                                            var store = cart.getStore();
                                            // dans tous les cas, on mets à jour les ruptures de stock
                                            if(store) store.fetchStockoutProduct();

                                            if(!cart.hasRequiredSidedishes(data.cross_selling_products_errors)) {
                                                // formules avec accompagnements obligatoires
                                                cart.alertRequiredSidedishes();
                                                cart.trigger('doPaymentError');
                                            }else{
                                                cart.once('sync',function(){
                                                    if(!cart.hasRequiredSidedishes()) {
                                                        cart.alertRequiredSidedishes();
                                                        cart.trigger('doPaymentError');
                                                    }else{
                                                        triggerError(data.error);
                                                    }
                                                })
                                                cart.remoteFetch();
                                            }
                                            return;
                                        case 'StockoutProductError':
                                            // en cas de rupture de stock
                                            if(callback) callback();
                                            // TODO
                                            // on rafraichit le panier pour mettre à jour les produits indisponibles
                                            cart.once('sync',function(){
                                                cart.checkProducts(true);
                                            });
                                            cart.remoteFetch();
                                            return
                                        default:
                                        case 'CartError':
                                            cart.remoteFetch();
                                            break;
                                        case 'CardError' :
                                            errorMessage.subtitle = app.t('Veuillez selectionner une carte bancaire', 'Payment');
                                            break;
                                        case 'CustomerMissingField':
                                            errorMessage.subtitle = data.error;
                                            app.getCustomer().remoteFetch();
                                            break;
                                        case 'CVCError':
                                            if(callback) callback();
                                            return app.trigger('CVCError',data);
                                        case 'InvalidReCaptcha':
                                            triggerError();
                                            return app.alertReCaptcha(data.error);
                                        case 'FavoriteProductMissingError':
                                            return cart.confirmFreeProductVoucher(callback);
                                        case 'FavoriteProductMissingAmountError':
                                            return cart.confirmFreeProductVoucherAmount(callback);
                                        case 'PaymentError' :
                                            // noop
                                    }
                                }
                            }else{
                                app.error('doPaymentException',JSON.parse(JSON.stringify(jqXHR)));
                            }
                            if (callback) {
                                callback();
                            }
                            triggerError(errorMessage);
                        })
                        .fail(function (jqXHR,status) {
                            var o = JSON.parse(JSON.stringify(orderOptions));
                            if(o && o.params && o.params.cvc){
                                // CVC obfuscation in error log.
                                o.params.cvc = 'XXX';
                            }
                            app.error('doPaymentError',{
                                status:status,
                                error:JSON.parse(JSON.stringify(jqXHR)),
                                options:o,
                                cart:cart.toJSON(),
                            });
                            triggerError(errorMessage);
                        })
                },
                doPayment: function (orderOptions, callback) {
                    var pm = paymentMode || paymentMethod;

                    if (_.isUndefined(pm)){
                        app.trigger('paymentModeRequirement',null);
                        return callback();
                    }

                    orderOptions = _(orderOptions).extend(pm.getOptions());

                    function pmCallback(success){
                        if(success){
                            checkProductsAndDoPaymentCall();
                        }else{
                            callback();
                        }
                    }

                    if(!pm.validateBeforeSubmit(pmCallback)){
                        return;
                    }

                    if (_.isUndefined(orderOptions.phone) || orderOptions.phone == '') {
                        callback();
                        app.alert({title: t('Champs manquant',CART_TRANSLATION_CONTEXT), subtitle: t('Veuillez saisir votre téléphone',CART_TRANSLATION_CONTEXT)});
                        return;

                    }



                    if (!_.isUndefined(cart.amountReduce)){
                        orderOptions.amountReduce =  cart.amountReduce;

                    }
                    if (!_.isUndefined(cart.token)){
                        orderOptions.token =  cart.token;

                    }
                    cart.token = "";
                    if (cart.productCanBeOffered() && !cart.hasProductOfferedSelected())
                    {

                        //
                        // si le processus a été interompu, on lui redemande
                        // afin d'éviter au maximum le burn de coupon non-utilisé
                        //
                        cart.confirmFreeProductVoucher(function(){
                            checkProductsAndDoPaymentCall();
                        });
                        return;

                    }

                    function checkProductsAndDoPaymentCall(){
                        cart.once('sync',function(){
                            if(cart.checkProducts(true,callback,function(){
                                cart.doPaymentCall(orderOptions, callback);
                            }));
                        });
                        cart.remoteFetch();
                    }
                    checkProductsAndDoPaymentCall();

                }

            };

            var CartModel = ObjectModel
                .extend(LocalStorage)
                .extend(CartModelPrototype);

            return CartModel;
        }

        var CartModelModule = {
            getConstructor: function (options) {
                return ScopedCartModel(options);
            },
            requireDeliveryOptions: function (type, cart, force, callback, options) {
                if (!cart) {
                    cart = app.getCart();
                }
                var modalView = new AddressAutocompleteView(_.defaults(options||{},{
                    theme: 'modal',
                    type: type,
                    autoSubmit: true,
                    cart:cart,
                }));
                modalView.on('close', function () {
                    modalView.off();
                    var complete = modalView.isComplete();
                    if (!complete && force) {
                        cart.requireDeliveryOptions(type, cart, force, callback);
                    }else if(_.isFunction(callback)){
                        // en cas de fin de l'appel et si il y a un callback,
                        // on l'execute
                        callback(complete);
                    }
                });
                // évite d'afficher une croix si c'est pour réouvrir la même modal
                if(force){
                    modalView.$('.btn-close').remove();
                }
                app.displayModal(modalView);
            }
        }


        return CartModelModule;
    });

